module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/247-somaliland-e61392e75f34a6b6b0e2f188022a62ad.svg";